import { useState } from "react";
import { ReactComponent as PhoneIcon } from "logic/src/components/icons/phone.svg";
import { ReactComponent as NewIcon } from "logic/src/components/icons/new.svg";
import { ReactComponent as CloaseIcon } from "logic/src/components/icons/close.svg";
import { Popover, QRCode } from "antd";
import moment from "moment";
import styles from "./index.module.scss";
import service from "./images/service.png";
import user from "logic/src/objects/user/model";

const SAVE_KEY = "appDownloadGuide_is_open";

const saveOpenInfo = () => {
  localStorage.setItem(SAVE_KEY, new Date().getTime().toString());
};

const AppDownLoadGuide = () => {
  const [open, setOpen] = useState(() => {
    let needOpen = true;
    if (user.isLogin) {
      const lastTime = localStorage.getItem(SAVE_KEY);

      if (lastTime) {
        needOpen = !moment(Number(lastTime)).isSame(moment(), "day");
      }
    }
    if (needOpen) {
      saveOpenInfo();
    }
    return needOpen;
  });
  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = () => {
    setOpen(pre => {
      // if (user.isLogin) {
      //   saveOpenInfo();
      // }
      return !pre;
    });
  };

  return (
    <Popover
      arrow={false}
      placement="bottomRight"
      rootClassName={styles.popover}
      zIndex={900}
      content={
        <div className={styles.qrcodeContainer}>
          <div onClick={hide} className={styles.closeBtn}>
            <CloaseIcon />
          </div>

          <div className={styles.item}>
            <div className={styles.title}>扫码咨询</div>
            <div className={styles.intro}>使用微信扫码添加客服</div>
            <img className={styles.qrcode} src={service} />
          </div>
          <div className={styles.item}>
            <div className={styles.leftBorder}></div>
            <div className={styles.title}>商量手机版</div>
            <div className={styles.intro}>现已推出移动版，欢迎扫码下载</div>
            <div className={styles.antQrcode}>
              <QRCode
                className={styles.antQrcodeImg}
                size={400}
                iconSize={380}
                color="#333333"
                bordered={false}
                value={window.location.origin + "/appDownload"}
              />
            </div>
          </div>
        </div>
      }
      title=""
      trigger="click"
      open={open}
      // onOpenChange={handleOpenChange}
    >
      <span onClick={handleOpenChange} className={styles.container}>
        <PhoneIcon className={styles.phoneIcon} />
        <span className={styles.text}>下载手机版</span>
        <NewIcon />
      </span>
    </Popover>
  );
};

export default AppDownLoadGuide;
